import React from 'react'
import {
    Box,
    BottomNavigation,
    BottomNavigationAction,
    Typography,
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Utils from '../../utils'
import { translate } from '../../helper'

function Location(props) {
    return (
        <svg
            id="uuid-7e7281d3-36a8-4f04-967b-7fb53d867a0b"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15.67 20.87"
            {...props}
        >
            <defs>
                <style>
                    {
                        `\n.uuid-1dfda3d4-1f62-418b-87a6-7ae39e9282ba {\nfill: none;\nfill-rule: evenodd;\nstroke: ${props.color};\nstroke-linecap: round;\nstroke-linejoin: round;\nstroke-width: .75px;\n}\n`
                    }
                </style>
            </defs>
            <g id="uuid-cc11bd66-e1a0-4c00-b41b-3b28fd898111">
                <path
                    className="uuid-1dfda3d4-1f62-418b-87a6-7ae39e9282ba"
                    d="M13.56,7.69c.02-.18.03-.36.03-.53C13.59,3.31,11.01.38,7.83.38S2.07,3.31,2.07,7.16c0,1.06.39,2.22.87,3.28.5,1.09,1.16,2.19,1.8,3.17.56.85,3.09,4.74,3.09,4.74,0,0,2.3-3.55,3.09-4.74.4-.6.8-1.25,1.17-1.92M7.83,8.47c-1.41,0-2.56-1.15-2.56-2.56s1.15-2.56,2.56-2.56,2.56,1.15,2.56,2.56-1.15,2.56-2.56,2.56ZM10.63,15.94c2.73.35,4.66,1.2,4.66,2.19,0,1.31-3.34,2.36-7.46,2.36S.38,19.43.38,18.13c0-.98,1.88-1.82,4.56-2.18M10.12,16.9c1.9.21,2.91.52,2.91,1.13,0,.79-2.33,1.17-5.19,1.17s-5.19-.38-5.19-1.17c0-.59.97-.9,2.83-1.12"
                />
                <circle cx={12.95} cy={9.81} r={0.84} />
            </g>
        </svg>
    )
}

function Quotes(props) {
    return (
        <svg
            id="uuid-9bb83642-023e-4552-a706-6722b630a2dc"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16.8 20.4"
            {...props}
        >
            <defs>
                <style>
                    {
                        `\n.uuid-6a3b5508-f8bb-41d3-b6a7-d372f2c6fb0f {\nfill: none;\nstroke: ${props.color};\nstroke-linecap: round;\nstroke-linejoin: round;\nstroke-width: .75px;\n}\n.uuid-7f561433-375c-4261-8239-0493fa47eace {\nfill-rule: evenodd;\n}\n`
                    }
                </style>
            </defs>
            <g id="uuid-71314df5-d961-4720-80fe-de7001fe3dd2">
                <path
                    id="uuid-e8db7e2d-f96e-438c-988e-dc6f3d7bf8fa"
                    className="uuid-7f561433-375c-4261-8239-0493fa47eace"
                    fill={props.color}
                    d="M13.03,14.41c-.06.06-.15.09-.23.08-.14,0-1.72-1.75-1.72-1.75-.11-.12-.09-.3.02-.41.11-.1.27-.1.38,0l1.23,1.36,3.1-4.84c.08-.16.28-.21.44-.13,0,0,0,0,0,0,.15.1.21.3.12.45,0,0-3.32,5.19-3.35,5.22Z"
                />
                <path
                    className="uuid-6a3b5508-f8bb-41d3-b6a7-d372f2c6fb0f"
                    d="M4.81,9.33h2.11c.7,0,1.26-.57,1.26-1.26h0c0-.7-.57-1.26-1.26-1.26h-.84c-.7,0-1.26-.57-1.26-1.26h0c0-.7.57-1.26,1.26-1.26h2.11M6.49,2.59v1.68M6.49,9.33v1.68"
                />
                <path
                    className="uuid-6a3b5508-f8bb-41d3-b6a7-d372f2c6fb0f"
                    d="M14.04,4.7V.38H.38v18.98l.35.39c.24.27.61.3.88.07l1.15-.97c.24-.2.57-.2.81,0l1.22,1.03c.24.2.57.2.81,0l1.21-1.03c.24-.2.57-.2.81,0l1.22,1.03c.24.2.57.2.8,0l1.22-1.03c.24-.2.57-.2.8,0l1.16.98c.27.23.64.2.88-.07l.35-.39v-1.95M16.12,11.39c.2.44.31.93.31,1.45,0,1.96-1.59,3.55-3.55,3.55s-3.55-1.59-3.55-3.55,1.59-3.55,3.55-3.55c.39,0,.77.06,1.12.18"
                />
                <circle fill={props.color} cx={14.04} cy={7.07} r={0.78} />
            </g>
        </svg>
    )
}

function Orders(props) {
    return (
        <svg
            id="uuid-51c51bbe-71fa-4124-94b7-66c21c52024e"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16.93 18.71"
            {...props}
        >
            <defs>
                <style>
                    {
                        `\n.uuid-240e83f7-00dc-41a0-9514-b5458c2b4f70 {\nfill: none;\nstroke: ${props.color};\nstroke-linecap: round;\nstroke-linejoin: round;\nstroke-width: .75px;\n}\n`
                    }
                </style>
            </defs>
            <g id="uuid-75b7b874-18f3-4afc-940c-4423aff2270c">
                <path
                    className="uuid-240e83f7-00dc-41a0-9514-b5458c2b4f70"
                    d="M14.49,3.83L8.36.38.38,4.86v8.98s7.98,4.49,7.98,4.49l7.98-4.49v-6.98M14.38,5.84l-6.02,3.01L.38,4.86M8.36,18.33v-9.48"
                />
                <polygon
                    id="uuid-caaee4a9-4a94-43d7-813b-b9486ac77619"
                    className="uuid-240e83f7-00dc-41a0-9514-b5458c2b4f70"
                    points="6.1 12.1 6.1 7.61 10.09 5.61 7.03 4.21 3.04 6.2 3.04 10.35 6.1 12.1"
                />
                <circle cx={16.13} cy={4.86} r={0.8} />
            </g>
        </svg>
    )
}

function Notification(props) {
    return (
        <svg
            id="uuid-dc4db577-96a0-4e2b-b2be-b64e21bd7bef"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16.91 19.23"
            {...props}
        >
            <defs>
                <style>
                    {
                        `\n.uuid-0f8af9de-17e9-4ef2-9694-f4b77f3cc795,\n.uuid-1471f63d-8be9-4025-8718-6a84ac05dc8f {\nstroke: ${props.color};\nstroke-linecap: round;\nstroke-linejoin: round;\nstroke-width: .75px;\n}\n.uuid-1471f63d-8be9-4025-8718-6a84ac05dc8f {\nfill: none;\n}\n`
                    }
                </style>
            </defs>
            <g id="uuid-c4df296d-b94d-4e05-b242-d7bdd439d00a">
                <path
                    className="uuid-1471f63d-8be9-4025-8718-6a84ac05dc8f"
                    d="M10.92,2.41c-.75-.36-1.59-.56-2.48-.56-3.21,0-5.81,2.61-5.81,5.82v5.63s0,.04,0,.05c-.02.65-.44,1.23-1.04,1.47l-.91.36c-.19.07-.31.26-.31.46v.96h16.16v-.96c0-.2-.12-.39-.31-.46l-.91-.36c-.61-.24-1.02-.81-1.04-1.47,0-.02,0-.04,0-.05v-5.58c0-.4-.04-.78-.12-1.16"
                />
                <path
                    className="uuid-1471f63d-8be9-4025-8718-6a84ac05dc8f"
                    d="M10.07,17.47c0,1.09-.87,1.38-1.93,1.38s-1.93-.29-1.93-1.38"
                />
                <path
                    className="uuid-1471f63d-8be9-4025-8718-6a84ac05dc8f"
                    d="M6.9,1.85v-.65c0-.71.84-.83,1.55-.83h0c.71,0,1.55.11,1.55.83v.65"
                />
                <circle
                    className="uuid-0f8af9de-17e9-4ef2-9694-f4b77f3cc795"
                    cx={12.72}
                    cy={4.27}
                    r={0.76}
                />
            </g>
        </svg>
    )
}

function Settings(props) {
    return (
        <svg
            id="uuid-ab6ba88c-84ab-40b9-9138-2e8fd454c666"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16.66 16.74"
            {...props}
            fill={props.color}
        >
            <g id="uuid-c87d1d2b-ad3b-40be-9fcd-77160397934c">
                <path

                    id="uuid-9fba2182-388a-4b86-bca3-d3630b58e4bf"
                    d="M10.23,8.01l-1.01.46c-.32-.43-.72-.81-1.17-1.1l.39-1.04c.08-.2-.02-.42-.22-.5l-1.01-.38c-.1-.04-.2-.03-.29,0s-.17.12-.2.21l-.39,1.04c-.53-.08-1.08-.07-1.6.05l-.46-1.01c-.04-.09-.12-.17-.21-.2-.1-.04-.2-.03-.29,0l-.98.44c-.19.09-.28.31-.19.51l.46,1.01c-.43.32-.81.72-1.1,1.17l-1.04-.39c-.2-.08-.42.02-.5.22L.02,9.52c-.04.1-.03.2,0,.29.04.09.12.17.21.2l1.04.39c-.08.53-.07,1.08.05,1.6l-1.01.46c-.09.04-.17.12-.2.21-.04.1-.03.2,0,.29l.44.98c.09.19.31.28.51.19l1.01-.46c.32.43.72.81,1.17,1.1l-.39,1.04c-.04.1-.03.2,0,.29.04.09.12.17.21.2l1.01.38c.2.08.42-.02.5-.22l.39-1.04c.53.08,1.08.07,1.6-.05l.46,1.01c.04.09.12.17.21.2.1.04.2.03.29,0l.98-.44c.09-.04.17-.12.2-.21.04-.1.03-.2,0-.29l-.46-1.01c.43-.32.81-.72,1.1-1.17l1.04.39c.2.08.42-.02.5-.22l.38-1.01s.02-.09.02-.14c0-.05-.01-.11-.03-.16-.04-.09-.12-.17-.21-.2l-1.04-.39c.08-.53.07-1.08-.05-1.6l1.01-.46c.09-.04.17-.12.2-.21.04-.1.03-.2,0-.29l-.44-.98c-.09-.19-.31-.28-.51-.19ZM6.58,8.65c1.01.38,1.68,1.36,1.68,2.44,0,.31-.06.63-.17.92-.25.65-.73,1.17-1.37,1.45-.63.29-1.34.31-1.99.06-1.01-.38-1.68-1.36-1.68-2.44,0-.31.06-.63.17-.92.25-.65.73-1.17,1.37-1.45.63-.29,1.34-.31,1.99-.06ZM11.83.1c-.08.07-.12.16-.12.27l-.03.72c-.34.07-.67.19-.98.36l-.49-.53c-.14-.16-.39-.17-.54-.02l-.58.53c-.08.07-.12.16-.12.27,0,.1.03.2.1.28l.49.53c-.19.29-.34.61-.44.94l-.72-.03c-.21,0-.39.16-.4.37l-.03.78c0,.21.16.39.37.4l.72.03c.07.34.19.67.36.98l-.53.49c-.08.07-.12.16-.12.27,0,.1.03.2.1.28l.53.58c.14.16.39.17.54.02l.53-.49c.29.19.61.34.94.44l-.03.72c0,.21.16.39.37.4l.78.03c.1,0,.2-.03.28-.1.08-.07.12-.16.12-.27l.03-.72c.34-.07.67-.19.98-.36l.49.53c.07.08.16.12.27.12.1,0,.2-.03.28-.1l.58-.53c.08-.07.12-.16.12-.27,0-.1-.03-.2-.1-.28l-.49-.53c.19-.29.34-.61.44-.94l.72.03c.21,0,.39-.16.4-.37l.03-.78s0-.01,0-.02c0-.1-.04-.19-.1-.26-.07-.08-.16-.12-.27-.12l-.72-.03c-.07-.34-.19-.67-.36-.98l.53-.49c.08-.07.12-.16.12-.27,0-.1-.03-.2-.1-.28l-.53-.58c-.14-.16-.39-.17-.54-.02l-.53.49c-.29-.19-.61-.34-.94-.44l.03-.72c0-.21-.16-.39-.37-.4L12.1,0c-.1,0-.2.03-.28.1ZM14.1,4.43c-.04.99-.88,1.76-1.87,1.71-.96-.04-1.72-.83-1.72-1.79,0-.03,0-.05,0-.08.04-.99.88-1.76,1.87-1.71.99.04,1.76.87,1.71,1.87Z"
                />
            </g>
        </svg>
    )
}

export default function Footer() {
    const location = useLocation()
    const navigate = useNavigate()
    const activeURL = location.pathname
    const isMobile = window.innerWidth <= 542;

    const authData = useSelector(state => state?.auth?.data)
    const role =
        authData?.user?.profile?.user?.role ||
        authData?.user?.role ||
        'user'

    const endpointType = activeURL.includes('/dealer')
        ? 'dealerTechnicianEndpoints'
        : 'userMobileEndpoints'

    const navItems = [
        {
            path: '/vendors',
            icon: Location,
            labels: { user: 'locations', DT: 'locations' },
            pathKey: 'vendors',
        },
        {
            path: '/quotes',
            icon: Quotes,
            labels: { user: 'acceptedQuotes', DT: 'acceptedQuotesDT' },
            pathKey: 'quotes',
        },
        {
            path: '/create-order',
            icon: Orders,
            labels: { user: 'orders', DT: 'order' },
            pathKey: 'createOrder',
        },
        {
            path: '/user-notification',
            icon: Notification,
            labels: { user: 'notifications', DT: 'notifications' },
            pathKey: 'userNotification',
        },
        {
            path: '/settings',
            icon: Settings,
            labels: { user: 'settings', DT: 'settings' },
            pathKey: 'settings',
        },
    ]

    const activeIndex = navItems.findIndex(item =>
        activeURL.includes(item.path)
    )

    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <BottomNavigation
                showLabels
                value={activeIndex === -1 ? 0 : activeIndex}
                onChange={(event, newValue) => {
                    const item = navItems[newValue]
                    navigate(Utils.EndPoint[endpointType][item.pathKey])
                }}
                sx={{
                    height: isMobile ? '64px' : '45px',
                    alignItems: 'flex-start',
                    '& .MuiBottomNavigationAction-root': {
                        color: '#383938',
                        width: '100%',
                        textDecoration: 'none',
                        cursor: 'pointer',
                        WebkitTapHighlightColor: 'white',
                        minWidth: '0',
                        flex: 1,
                        maxWidth: 'none',
                        padding: '5px 0',
                        '& .MuiBottomNavigationAction-wrapper': {
                            flexDirection: 'column',

                            gap: '4px',
                        },

                    }, '& svg': {
                        width: 24,
                        height: 24,
                        flexShrink: 0,
                    },
                }}
            >
                {navItems.map((item, index) => {
                    const isActive = activeURL.includes(item.path)
                    const Icon = item.icon
                    const color = isActive ? '#FBC916' : '#383938'

                    return (
                        <BottomNavigationAction
                            key={item.path}
                            icon={<Icon color={color} />}
                            label={
                                <Typography
                                    sx={{
                                        fontSize: '12px',
                                        fontWeight: isActive ? 600 : 500,
                                        color,
                                        textAlign: 'center',
                                    }}
                                >
                                    {translate(item.labels[role])}
                                </Typography>
                            }
                        />
                    )
                })}
            </BottomNavigation>
        </Box>
    );
}
